import { render, staticRenderFns } from "./Cassa.vue?vue&type=template&id=e3f060a2"
import script from "./Cassa.vue?vue&type=script&lang=js"
export * from "./Cassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports